module.exports = __webpack_public_path__ + "static/media/CG.89bb64c1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/CG.svg
// module id = 222
// module chunks = 0